let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8kHli")).then(() => parcelRequire('c4u14'));